import React, { useEffect } from "react";
import "./StoreChoiceModal.css";

const StoreChoiceModal = ({
  isOpen,
  onClose,
  onSelectOldStore,
  onSelectNewStore,
}) => {
  useEffect(() => {
    if (!isOpen) return;
    const handleKeyDown = (e) => {
      if (e.key === "Escape") onClose();
    };
    window.addEventListener("keydown", handleKeyDown);
    return () => window.removeEventListener("keydown", handleKeyDown);
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  return (
    <div
      className="store-choice-modal__backdrop"
      onClick={onClose}
      role="dialog"
      aria-modal="true"
      aria-labelledby="store-choice-title"
    >
      <div
        className="store-choice-modal__dialog"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          className="store-choice-modal__close-btn"
          onClick={onClose}
          aria-label="Close dialog"
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <line x1="18" y1="6" x2="6" y2="18" />
            <line x1="6" y1="6" x2="18" y2="18" />
          </svg>
        </button>

        <header className="store-choice-modal__header">
          <div className="store-choice-modal__tag">
            <svg
              width="14"
              height="14"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <path d="M6 2L3 6v14a2 2 0 0 0 2 2h14a2 2 0 0 0 2-2V6l-3-4z" />
              <line x1="3" y1="6" x2="21" y2="6" />
              <path d="M16 10a4 4 0 0 1-8 0" />
            </svg>
            Motion Store
          </div>
          <h2 id="store-choice-title" className="store-choice-modal__title">
            Explore Motion Store
          </h2>
          <p className="store-choice-modal__subtitle">
            Choose how you would like to explore our courses and learning material.
          </p>
        </header>

        <div className="store-choice-modal__grid">
          {/* Old Store (Classic) */}
          <div className="store-choice-card store-choice-card--classic">
            <div>
              <span className="store-choice-card__badge">Classic Catalog</span>
              <div className="store-choice-card__icon-wrap">
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <rect x="3" y="3" width="7" height="7" />
                  <rect x="14" y="3" width="7" height="7" />
                  <rect x="14" y="14" width="7" height="7" />
                  <rect x="3" y="14" width="7" height="7" />
                </svg>
              </div>
              <h3 className="store-choice-card__name">Old Store</h3>
              <p className="store-choice-card__desc">
                Browse traditional categorized courses, test series, and books.
              </p>

              <ul className="store-choice-card__features">
                <li className="store-choice-card__feature-item">
                  <svg
                    className="store-choice-card__tick"
                    width="16"
                    height="16"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Category-based package browsing</span>
                </li>
                <li className="store-choice-card__feature-item">
                  <svg
                    className="store-choice-card__tick"
                    width="16"
                    height="16"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Topper choice & Recommended cards</span>
                </li>
                <li className="store-choice-card__feature-item">
                  <svg
                    className="store-choice-card__tick"
                    width="16"
                    height="16"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Books & Handbook carousel</span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              className="store-choice-card__btn store-choice-card__btn--classic"
              onClick={onSelectOldStore}
            >
              <span>Explore Old Store</span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14" />
                <path d="M12 5l7 7-7 7" />
              </svg>
            </button>
          </div>

          {/* New Store (Upgraded) */}
          <div className="store-choice-card store-choice-card--new">
            <div>
              <span className="store-choice-card__badge">✨ Upgraded & Recommended</span>
              <div className="store-choice-card__icon-wrap">
                <svg
                  width="26"
                  height="26"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  strokeWidth="2"
                  strokeLinecap="round"
                  strokeLinejoin="round"
                >
                  <polygon points="12 2 15.09 8.26 22 9.27 17 14.14 18.18 21.02 12 17.77 5.82 21.02 7 14.14 2 9.27 8.91 8.26 12 2" />
                </svg>
              </div>
              <h3 className="store-choice-card__name">New Store</h3>
              <p className="store-choice-card__desc">
                Interactive plan builder — customise Learn, Practice & Test bundles.
              </p>

              <ul className="store-choice-card__features">
                <li className="store-choice-card__feature-item">
                  <svg
                    className="store-choice-card__tick"
                    width="16"
                    height="16"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Build your own plan (Learn | Practice | Test)</span>
                </li>
                <li className="store-choice-card__feature-item">
                  <svg
                    className="store-choice-card__tick"
                    width="16"
                    height="16"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Delta Upgrade: Save with credit from existing plan</span>
                </li>
                <li className="store-choice-card__feature-item">
                  <svg
                    className="store-choice-card__tick"
                    width="16"
                    height="16"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z"
                      clipRule="evenodd"
                    />
                  </svg>
                  <span>Flexible 6m / 1y / 2y duration options</span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              className="store-choice-card__btn store-choice-card__btn--new"
              onClick={onSelectNewStore}
            >
              <span>Explore New Store</span>
              <svg
                width="16"
                height="16"
                viewBox="0 0 24 24"
                fill="none"
                stroke="currentColor"
                strokeWidth="2"
                strokeLinecap="round"
                strokeLinejoin="round"
              >
                <path d="M5 12h14" />
                <path d="M12 5l7 7-7 7" />
              </svg>
            </button>
          </div>
        </div>

        <footer className="store-choice-modal__footer">
          <svg
            width="14"
            height="14"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <circle cx="12" cy="12" r="10" />
            <line x1="12" y1="16" x2="12" y2="12" />
            <line x1="12" y1="8" x2="12.01" y2="8" />
          </svg>
          <span>You can switch between Old and New Store anytime using the toggle on the store page.</span>
        </footer>
      </div>
    </div>
  );
};

export default StoreChoiceModal;
